import { cva } from 'class-variance-authority';

export { cva };
export type { VariantProps } from 'class-variance-authority';

export const focusRing =
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--tk-brand-ring)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--tk-surface-bg)]';

export const disabledStyles =
  'disabled:opacity-50 disabled:pointer-events-none disabled:cursor-not-allowed';

export const transitionBase = 'transition-colors duration-200 ease-out';
